import React from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import Tab from "semantic-ui-react/dist/commonjs/modules/Tab";
import { SearchCondition } from "./SearchCondition";
import { SearchKeyword } from "./SearchKeyword";

/* eslint-disable max-params */
export const search_tab = ({ type, match }, pref, value, onSearch) => {
  const pane_1 = pref && (
    <div>
      <SearchCondition
        {...{ type, match }}
        mode="area"
        value={value && value.condition}
        onSearch={value => onSearch({ condition: value })}
      />
    </div>
  );
  const pane_2 = pref && (
    <div>
      <SearchCondition
        {...{ type, match }}
        mode="line"
        value={value && value.condition}
        onSearch={value => onSearch({ condition: value })}
      />
    </div>
  );  
  const pane_3 = (
    <SearchKeyword
      {...{ type,  match }}
      value={value && value.condition}
      onSearch={value => onSearch({ condition: value })}
    />
  );
  const panes = [
    pane_1 && {
      menuItem: type === TYPE_PC ? 'エリアから探す' : "エリア",
      pane: {
        key: "pane_1",
        content: pane_1,
      },
    },
    pane_2 && {
      menuItem: type === TYPE_PC ? '路線から探す' : "路線",
      pane: {
        key: "pane_2",
        content: pane_2,
      },
    },
    {
      menuItem: type === TYPE_PC ? 'キーワードで探す' : "キーワード",
      pane: {
        key: "pane_3",
        content: pane_3,
      },
    },
  ].filter(item => item);
  return (
    <div className="search_tab">
      <Tab panes={panes} renderActiveOnly={false} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/area/search_tab.jsx